import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_ef1f9f15 from '../styles/Tabs.module.less.js';

/**
 * @description TabPane component.
 *
 * @component
 * @example
 * ```jsx
 * <TabPane key="tab-2" title="Tab">Content</TabPane>
 * ```
 */
const TabPane = React.forwardRef((props, ref) => {
    const { className, children, title: _, ...restProps } = props;
    const cx = useStyles(modules_ef1f9f15);
    const classNames = cx(className, 'pane');
    return (
    // @ts-ignore
    React.createElement("div", { ref: ref, "data-qa": "TabPane", className: classNames, ...restProps }, children));
});
TabPane.defaultProps = {};
TabPane.displayName = 'TabPane';

export { TabPane };
//# sourceMappingURL=TabPane.js.map
